import { ScrollTrigger } from "gsap/ScrollTrigger";
import SVGInjector from "svg-injector";
gsap.registerPlugin(ScrollTrigger);
const lenis = new Lenis({
	duration: 1, // Thời gian cuộn (càng cao càng mượt/chậm)
	easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Hàm easing mặc định
});

$(function () {
	// Initialize Lenis

	lenis.on('scroll', ScrollTrigger.update);

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000);
	});

	gsap.ticker.lagSmoothing(0);

	trackingSection()

	try {
		heroPlayAnimation();
		homeIntroduceAnimation()
		homeUrbanismAnimation()
		homeLocationImageAnimation()
		homeArchitectureAnimation()
		homeLobbyGalleryAnimation()
		home360Animation()
	} catch (error) {

	}

});

function getStartPauseAmount() {
	return window.innerHeight * 0.1;
}


function heroPlayAnimation() {
	SVGInjector(document.querySelectorAll(".inject-play"), {}, function (totalSVGsInjected) {
	});
}

function homeIntroduceAnimation() {
	const section = document.getElementById("home-introduction");
	const frontBg = section.querySelector(".bg .front");

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			invalidateOnRefresh: true,
			scrub: 1,
			start: "top 50%",
			end: "top top",
		}
	});

	tl.to(frontBg, {
		scale: 1,
		ease: "power2.out",
		duration: 1
	}, "<");

}

function homeUrbanismAnimation() {
	// --- LOGIC SCROLL NGANG CŨ ---

	const section = document.getElementById("home-urbanism");
	const content = document.querySelector(".home-urbanism-content");
	const rightWrapper = document.querySelector(".right-content-wrapper");
	const mask = document.querySelector(".mask");

	const parallaxElements = gsap.utils.toArray(".home-urbanism-right .item-title-wrapper, .home-urbanism-right img");

	// 2. TÍNH TOÁN
	function getHorizontalScrollAmount() {
		return content.scrollWidth - window.innerWidth;
	}

	function getVerticalScrollAmount() {
		const contentHeight = rightWrapper.scrollHeight;
		const viewportHeight = window.innerHeight;
		return Math.max(0, contentHeight - viewportHeight);
	}

	function getMiddlePauseAmount() {
		return window.innerHeight;
	}



	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			pin: true,
			scrub: 1,
			start: "top top",
			end: () => "+=" + (getHorizontalScrollAmount() + getVerticalScrollAmount() + 120),
			invalidateOnRefresh: true,
		}
	});

	tl.to({}, { duration: () => getStartPauseAmount() });

	// --- PHASE 1: SCROLL NGANG ---
	tl.to(content, {
		x: () => -getHorizontalScrollAmount(),
		ease: "none",
		duration: () => getHorizontalScrollAmount()
	});

	tl.to(rightWrapper, {
		y: () => -getVerticalScrollAmount(),
		ease: "none",
		duration: () => getVerticalScrollAmount()
	});

	tl.to(mask, {
		yPercent: 30,
		ease: "none",
		duration: () => getVerticalScrollAmount()
	}, "<");

	tl.to(parallaxElements, {
		yPercent: -10,
		ease: "none",
		stagger: 0.2,
		duration: () => getVerticalScrollAmount()
	}, "<");

}

function homeLocationImageAnimation() {
	const section = document.getElementById("home-location-image");
	const bg = section.querySelector(".bg");

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			scrub: 1,
			start: "top bottom",
			end: "top top",
			invalidateOnRefresh: true,
		}
	});

	tl.to(bg, {
		y: 0,
		ease: "none",
		duration: 1
	}, "<");
}

function homeArchitectureAnimation() {
	const section = document.getElementById("home-architecture");
	const bg2 = section.querySelector(".bg.second");

	const content = section.querySelector(".home-architecture-content");

	const rightWrapper = section.querySelector(".home-architecture-right");
	const itemList = section.querySelector(".item-list");


	// --- 1. TÍNH TOÁN CÁC THÔNG SỐ SCROLL ---

	function getTransitionScrollAmount() {
		return window.innerWidth;
	}
	function getBgRevealAmount() {
		return window.innerHeight;
	}

	function getStartPauseAmount() {
		return window.innerHeight * 0.2;
	}

	function getMiddlePauseAmount() {
		return window.innerHeight * 0.2;
	}

	function getItemScrollAmount() {
		// itemList.scrollWidth: Tổng chiều dài của list
		// window.innerWidth: Chiều rộng vùng hiển thị
		// Trừ đi một chút padding nếu cần
		return itemList.scrollWidth - window.innerWidth;
	}

	// --- 2. THIẾT LẬP TIMELINE ---

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			scrub: 1,
			pin: true,
			start: "top top",
			end: () => "+=" + (getStartPauseAmount() + getBgRevealAmount() + getMiddlePauseAmount() + getItemScrollAmount() + getTransitionScrollAmount()),
			invalidateOnRefresh: true,
		}
	});

	// PHASE 1: START PAUSE
	tl.to({}, { duration: () => getStartPauseAmount() });

	// PHASE 2: REVEAL BG2 (Sử dụng 'y' pixel)
	// Sử dụng fromTo để đảm bảo trạng thái bắt đầu/kết thúc chính xác
	tl.fromTo(bg2, {
		y: () => window.innerHeight, // Bắt đầu ở dưới cùng màn hình (pixel)
		yPercent: 0 // Reset percent vì CSS đang dùng translateY(100%)
	}, {
		y: 0, // Trượt lên vị trí gốc (pixel)
		ease: "none",
		duration: () => getBgRevealAmount()
	});

	// PHASE 3: MIDDLE PAUSE
	tl.to({}, { duration: () => getMiddlePauseAmount() });

	// PHASE 4: SCROLL NGANG
	tl.to(content, {
		x: () => -window.innerWidth,
		ease: "none",
		duration: () => getTransitionScrollAmount()
	});

	tl.to({}, { duration: () => getMiddlePauseAmount() });


	tl.to(itemList, {
		x: () => -getItemScrollAmount(),
		ease: "none",
		duration: () => getItemScrollAmount()
	});

	tl.to({}, { duration: () => getMiddlePauseAmount() });
}

function homeLobbyGalleryAnimation() {
	const section = document.getElementById("home-lobby-gallery");
	const homeLobbyCite = section.querySelector(".home-lobby-cite");


	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			scrub: 1,
			start: "top bottom",
			end: "top top",
			invalidateOnRefresh: true,
		}
	});

	tl.to(homeLobbyCite, {
		x: 0,
		y: 0,
		ease: "none",
		duration: 1
	}, "<");
}

function home360Animation() {
	const section = document.getElementById("home-360");
	const planItems = section.querySelectorAll(".plan-item");
	const rotator = section.querySelector(".rotator");
	const bg = section.querySelector(".bg");

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			start: "top bottom",
			end: "top top",
			invalidateOnRefresh: true,
		}
	});

	tl.to(rotator, {
		rotation: 360,
		duration: 20,
		repeat: -1,
		ease: "none",
	});

	tl.to(planItems, {
		opacity: 1,
		x: 0,
		ease: "power2.out",
		duration: 2,
		stagger: 0.2,
	}, "<");

}


function trackingSection() {
	// 2. XỬ LÝ CLICK VÀO NAV ITEM (Smooth Scroll bằng Lenis)
	const navLinks = document.querySelectorAll('.fixed-nav a');

	const sidebar = document.querySelector('.fixed-nav');
	let debounceTimer = null;

	// Hàm thay đổi trạng thái Sidebar có độ trễ (Debounce)
	function updateSidebarState(shouldShow, theme) {
		// Xóa lệnh cũ (Debounce logic)
		clearTimeout(debounceTimer);

		// Đặt lệnh mới
		debounceTimer = setTimeout(() => {
			// 1. Xử lý Ẩn/Hiện
			if (shouldShow) {
				sidebar.classList.add('is-visible');
			} else {
				sidebar.classList.remove('is-visible');
			}

			// 2. Xử lý Theme (White/Dark)
			if (theme === 'white') {
				sidebar.classList.add('is-white');
			} else {
				sidebar.classList.remove('is-white');
			}
		}, 200); // Delay 100ms
	}


	// 4. OBSERVER
	const sections = document.querySelectorAll('[data-observe]');

	const observerOptions = {
		root: null,
		rootMargin: '-50% 0px -50% 0px', // Vẫn giữ line ở giữa màn hình
		threshold: 0
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			const id = entry.target.getAttribute('id');
			const link = document.querySelector(`.fixed-nav a[href="#${id}"]`);

			// Lấy các attributes từ HTML
			const shouldHideNav = entry.target.dataset.hideNav === "true";
			const sectionTheme = entry.target.dataset.theme; // 'white' hoặc undefined

			if (entry.isIntersecting) {
				// Active Link
				navLinks.forEach(l => l.classList.remove('active'));
				if (link) link.classList.add('active');

				// Gọi hàm update state với logic Debounce
				// Tham số 1: Có hiện sidebar không? (Ngược lại với hideNav)
				// Tham số 2: Theme là gì?
				updateSidebarState(!shouldHideNav, sectionTheme);
			}
		});
	}, observerOptions);

	sections.forEach(section => {
		observer.observe(section);
	});
}
